const DEFAULT_LIMIT = 10;

export const useSearchQueryParams = (
  filter: {
    query?: string;
    group?: string;
    limit?: number;
  },
  limit: number = DEFAULT_LIMIT,
): string => {
  const params = new URLSearchParams();

  params.append('limit', limit.toString());

  if (filter.group) {
    params.append('group', filter.group);
  }

  if (filter.query) {
    params.append('query', filter.query);
  }

  return params.toString() ? `?${params.toString()}` : '';
};
